export const SITE_URL =
  import.meta.env.VITE_SITE_URL || "https://meriana.app";

// The product app lives at /app on the same domain. These deep-link into the
// app's auth screens. Same-origin absolute paths so they work in dev and prod.
// NOTE: keep the trailing slash on "/app/". The server 301-redirects "/app" ->
// "/app/", and that extra redirect hop is dropped silently by some mobile
// in-app browsers/webviews, making the CTA appear to "go nowhere". Linking
// straight to the canonical "/app/" URL avoids the redirect entirely.
export const SIGNUP_URL = "/app/?auth=register";
export const SIGNIN_URL = "/app/?auth=login";
// CCPA/CPRA "Do Not Sell or Share" opt-out lives in the app's Account view.
export const DO_NOT_SELL_URL = "/app/?view=account#do-not-sell";
